<template>
  <transition :name="transition">
    <div class="gp-tab-header" v-if="index == activeIndex">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: "GpTabHeader",
  props: {
    label: String,
    index: [String, Number],
    activeIndex: [String, Number],
    animate: String
  },
  data() {
    return {
      transition: "fade"
    };
  },
  watch: {
    animate() {}
  }
};
</script>

<style lang="scss" scoped>
.fade {
  &-enter-active {
    animation: fade 0.5s;
  }
  &-leave-active {
    display: none;
  }
}
.next {
  &-enter-active {
    animation: next 0.5s;
  }
  &-leave-active {
    // display: none;
    animation: prev 0.5s;
  }
}
.prev {
  &-enter-active {
    animation: prev 0.5s;
  }
  &-leave-active {
    animation: next 0.5s;
    // display: none;
  }
}
@keyframes fade {
  from {
    opacity: 0;
    // display: none;
  }

  to {
    opacity: 1;
  }
}
@keyframes next {
  from {
    opacity: 0;
    // transform: translate3d(100%, 0, 0);
    position: absolute;
    left: -100%;
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    position: absolute;
    left: -0;
  }
}
@keyframes prev {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
</style>
